<template lang="pug">
li(:id="id")
  router-link(:active="active" :to="fullPath")
    .name
      FontAwesomeIcon.icon(:icon="icon")
      p {{ name }}
    
    .pills.collapsed-hide(v-if="pills && pills.isVisible")
      b-badge.badge-amber(v-if="pills && pills.top" pill) {{ pills.top.text }}
  </template>

<script>
import { Route } from "@gemma/utils";
import { Routing } from "@timesheets/webapp-support";

export default {
  name: "SidebarMenuItem",
  props: {
    initialActive: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    pills: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      active: this.initialActive,
    };
  },
  computed: {
    fullPath() {
      const route = new Route(this.to);
      if (route.searchTerms.roleId) {
        return this.to;
      }

      Routing.ensureRoleIdOnUrl(route, this.currentRole);

      return route.fullPath;
    },
  },
};
</script>
